import { Tooltip } from "antd";
import React from "react";
import { ModalCargaComplemento } from "./_ModalCargaComplemento";
import { CloudUploadOutlined } from "@ant-design/icons";

export const Complemento = ({ orden }) => {
  const [open, setOpen] = React.useState(false);

  if (orden.estatusOrdenPagoID !== 6) return <></>;
  return (
    <>
      <Tooltip title="Cargar Complemento de Pago">
        <CloudUploadOutlined
          onClick={() => setOpen(true)}
          className="eyeIcon"
          style={{ fontSize: 20, color: "green" }}
        />
      </Tooltip>
      <ModalCargaComplemento open={open} setOpen={setOpen} orden={orden}/>
    </>
  );
};
